import React from 'react';
import ReactDOM from 'react-dom';
import { ConnectedCourseAlertBanners } from './connector';

export const CourseAlertBanners = () => {
  const bannerMountElem = document.getElementById('course-alert-banner-mount');

  if (bannerMountElem) {
    return ReactDOM.createPortal(
      <ConnectedCourseAlertBanners />,
      bannerMountElem
    );
  }
  return null;
};
